import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FaCog, FaTimes } from 'react-icons/fa';
import { useDevTools } from '../../context/DevToolsContext';
import { disableDevTools } from '../../utils/devTools';
import './DevToolsPanel.css';

export default function DevToolsPanel() {
  const location = useLocation();
  const { enabled, loading, setLoadingOverride, resetLoadingOverrides } = useDevTools();
  const [minimized, setMinimized] = useState(false);

  if (!enabled) return null;

  const onProposalRoute = location.pathname === '/backyard-proposal';

  const handleHide = () => {
    disableDevTools();
    window.location.reload();
  };

  return (
    <div className={`dev-tools${minimized ? ' is-minimized' : ''}`}>
      <div className="dev-tools__panel">
        <header className="dev-tools__head">
          <button
            type="button"
            className="dev-tools__head-main"
            onClick={() => setMinimized(m => !m)}
            aria-expanded={!minimized}
          >
            <FaCog aria-hidden="true" />
            {!minimized ? <span>Dev Tools</span> : null}
          </button>
          {!minimized ? (
            <button type="button" className="dev-tools__icon-btn" onClick={handleHide} aria-label="Hide dev tools">
              <FaTimes />
            </button>
          ) : null}
        </header>

        {!minimized ? (
          <div className="dev-tools__body">
            <section className="dev-tools__section">
              <h3>Loading overlays</h3>
              <p className="dev-tools__note">Toggle loaders without triggering real async work.</p>

              <label className="dev-tools__row">
                <input
                  type="checkbox"
                  checked={loading.forceGlobal}
                  onChange={e => setLoadingOverride('forceGlobal', e.target.checked)}
                />
                <span>
                  <strong>Global loader</strong>
                  <small>Frost overlay via LoadingContext</small>
                </span>
              </label>

              <label className="dev-tools__row">
                <input
                  type="checkbox"
                  checked={loading.forceProposal}
                  onChange={e => setLoadingOverride('forceProposal', e.target.checked)}
                />
                <span>
                  <strong>Proposal loader</strong>
                  <small>{onProposalRoute ? 'Active on this route' : 'Open /backyard-proposal to preview'}</small>
                </span>
              </label>

              {(loading.forceProposal || onProposalRoute) ? (
                <>
                <div className="dev-tools__slider">
                  <label htmlFor="dev-proposal-progress">
                    Proposal progress
                    <span>{loading.proposalProgress}%</span>
                  </label>
                  <input
                    id="dev-proposal-progress"
                    type="range"
                    min="0"
                    max="100"
                    step="1"
                    value={loading.proposalProgress}
                    onChange={e => setLoadingOverride('proposalProgress', Number(e.target.value))}
                    disabled={!loading.forceProposal && !onProposalRoute}
                  />
                </div>

                <div className="dev-tools__field">
                  <label htmlFor="dev-proposal-phase">Proposal panel</label>
                  <select
                    id="dev-proposal-phase"
                    value={loading.proposalPhase ?? 'auto'}
                    onChange={e => {
                      const v = e.target.value;
                      setLoadingOverride('proposalPhase', v === 'auto' ? null : v);
                    }}
                  >
                    <option value="auto">Auto (load → verify)</option>
                    <option value="loading">Loading only</option>
                    <option value="verify">Email verification</option>
                  </select>
                </div>
                </>
              ) : null}

              <button type="button" className="dev-tools__reset" onClick={resetLoadingOverrides}>
                Reset loading overrides
              </button>
            </section>

            <section className="dev-tools__section dev-tools__help">
              <h3>Enable / disable</h3>
              <code>?show-devtools=true</code>
              <code>document.cookie = &quot;show-devtools=true; path=/; max-age=31536000; SameSite=Lax&quot;</code>
            </section>
          </div>
        ) : null}
      </div>
    </div>
  );
}
